export default __webpack_public_path__ + "static/media/image 763.a995e2f8.png";